import { useTranslation } from 'react-i18next';

export default function WhyUs() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: 'ri-flashlight-line',
      title: t('whyUs.card1Title'),
      desc: t('whyUs.card1Desc'),
    },
    {
      icon: 'ri-layout-grid-line',
      title: t('whyUs.card2Title'),
      desc: t('whyUs.card2Desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('whyUs.card3Title'),
      desc: t('whyUs.card3Desc'),
    },
  ];

  return (
    <section className="w-full bg-secondary-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 text-center mb-14">
          {t('whyUs.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 md:p-8 text-center transition-all hover:scale-[1.02]">
              <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${card.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}